import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { rehypeGroupCmsRowText } from "@/lib/rehypeGroupCmsRowText";

/**
 * MarkdownRenderer — renders CMS markdown. Accepts raw HTML via `rehype-raw` so
 * authors can drop in layout helpers directly from the markdown editor, e.g.:
 *
 *   <div class="cms-columns">                two-column flowing text
 *     Paragraph 1...
 *
 *     Paragraph 2...
 *   </div>
 *
 *   <div class="cms-row">                    side-by-side image + text row
 *     ![alt](https://…/image.png)
 *
 *     Right-side paragraph text.
 *   </div>
 *
 * Styles for `.cms-columns` / `.cms-row` live in `index.css` under `.prose-editorial`.
 */
export function MarkdownRenderer({ source, className = "" }) {
  return (
    <div className={`prose-editorial ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw, rehypeGroupCmsRowText]}
      >
        {source || ""}
      </ReactMarkdown>
    </div>
  );
}
